import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

import type { Service } from "../service";

const INQUIRY = "inquiry";
const CREATE = "create";
const UPDATE = "update";
const DELETE = "delete";
const RESOLVE = "resolve";
const GET = "get";
const GET_MANY = "getMany";
const GET_PAGINATED = "getPaginated";

const MUTATION_KEYS = {
  [CREATE]: [INQUIRY, CREATE],
  [UPDATE]: [INQUIRY, UPDATE],
  [DELETE]: [INQUIRY, DELETE],
  [RESOLVE]: [INQUIRY, RESOLVE],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(INQUIRY, {
  [GET]: (params: Parameters<Service[typeof GET]>[0]) => [params],
  [GET_MANY]: null,
  [GET_PAGINATED]: (params: Parameters<Service[typeof GET_PAGINATED]>[0]) => [params],
});

export {
  CREATE,
  DELETE,
  GET,
  GET_MANY,
  GET_PAGINATED,
  INQUIRY,
  MUTATION_KEYS,
  QUERY_KEYS,
  RESOLVE,
  UPDATE,
};
